export default __webpack_public_path__ + "static/media/head_1_male.6bf6e7b5.png";